import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SelectTeam } from 'src/app/shared/models/type-list';
 
export interface SelectedNavigation {
  plant_name: string;
  line: string;
  subline: string;
}
 
export interface SelectionState {
  selectedTeams: SelectTeam[];
  expandedNavigation: SelectedNavigation;
}
 
@Injectable({
  providedIn: 'root'
})
export class SelectedService {
  
  private selectedTeamsSubject = new BehaviorSubject<SelectTeam[]>([]);
  public selectedTeams$ = this.selectedTeamsSubject.asObservable();
 
  private expandedNavigationSubject = new BehaviorSubject<SelectedNavigation>({
    plant_name: '',
    line: '',
    subline: ''
  });
  public expandedNavigation$ = this.expandedNavigationSubject.asObservable();
 
  constructor() {  }
 
  /**
   * Update selected teams and persist to sessionStorage
   * @param teams Selected team items to store
   */
  updateSelectedTeams(teams: SelectTeam[]): void {
    this.selectedTeamsSubject.next(teams);
  }
 
  /**
   * Get current selected teams
   * @returns Current selected teams as Observable
   */
  getSelectedTeams(): Observable<SelectTeam[]> {
    return this.selectedTeams$;
  }
 
  /**
   * Get selected teams synchronously (current value)
   * @returns Current selected teams array
   */
  getSelectedTeamsValue(): SelectTeam[] {
    return this.selectedTeamsSubject.value;
  }
 
  /**
   * Update expanded navigation state (plant, line, subline)
   * @param navigation Navigation path to store
   */
  updateExpandedNavigation(navigation: SelectedNavigation): void {
    this.expandedNavigationSubject.next(navigation);
  }
 
  /**
   * Get current expanded navigation
   * @returns Current expanded navigation as Observable
   */
  getExpandedNavigation(): Observable<SelectedNavigation> {
    return this.expandedNavigation$;
  }
 
  /**
   * Get expanded navigation synchronously (current value)
   * @returns Current expanded navigation
   */
  getExpandedNavigationValue(): SelectedNavigation {
    return this.expandedNavigationSubject.value;
  }
 
  /**
   * Clear all selections
   */
  clearSelections(): void {
    this.selectedTeamsSubject.next([]);
    this.expandedNavigationSubject.next({
      plant_name: '',
      line: '',
      subline: ''
    });
  }
 
  /**
   * Get entire selection state
   * @returns Combined selection state
   */
  getSelectionState(): SelectionState {
    return {
      selectedTeams: this.selectedTeamsSubject.value,
      expandedNavigation: this.expandedNavigationSubject.value
    };
  }
 
  /**
   * Set entire selection state
   * @param state Selection state to set
   */
  setSelectionState(state: SelectionState): void {
    if (state.selectedTeams) {
      this.selectedTeamsSubject.next(state.selectedTeams);
    }
    if (state.expandedNavigation) {
      this.expandedNavigationSubject.next(state.expandedNavigation);
    }
  }
}
 